<template>
    <div>
        <v-container>
            <v-row>

                <activity-select :disableComponent="show_all_activities"/>
                <!--        <v-switch-->
                <!--                class="ml-3 mr-5"-->
                <!--                v-model="show_including_vat"-->
                <!--                label="Inkludera moms">-->
                <!--        </v-switch>-->
                <!--        <v-switch-->
                <!--                class="ml-3 mr-5"-->
                <!--                v-model="show_all_activities"-->
                <!--                label="Visa alla aktiviteter">-->
                <!--        </v-switch>-->

            </v-row>
            <FromToDateFilter/>
        </v-container>
        <v-container>
            <statistic-card
                    :card-data="discount_codes"
                    :is-loading="discount_codes_are_loading"
            />
        </v-container>
    </div>
</template>

<script>
    import axios from "axios";
    import ActivitySelect from "@/components/ActivitySelect";
    import StatisticCard from "@/components/StatisticCard";
    import {mapGetters, mapState} from "vuex";
    import FromToDateFilter from "@/components/FromToDateFilter";

    export default {
        name: "DiscountCodes",
        components: {
            ActivitySelect,
            StatisticCard,
            FromToDateFilter,
        },
        mounted() {
            if (this.isAuthenticated) {
                this.loadAllData();
            }
        },
        data: () => ({
            show_all_activities:false,
            discount_codes_are_loading: true,
            discount_codes: [],
        }),
        computed: {
            ...mapGetters('common', [
                'serverURL',
            ]),
            ...mapGetters('auth', [
                'isAuthenticated',
            ]),
            ...mapState('common', [
                'selectedArea',
                'selectedActivity',
                'selectedFromDate',
                'selectedToDate',
            ]),
        },
        watch: {
            selectedActivity() {
                this.loadAllData();
            },
            isAuthenticated() {
                if (this.isAuthenticated) {
                    this.loadAllData();
                }
            },
            selectedFromDate() {
                this.loadDiscountCodes();
            },
            selectedToDate() {
                this.loadDiscountCodes();
            },
        },
        methods: {
            loadAllData() {
                this.loadDiscountCodes();
            },
            loadDiscountCodes() {
                this.discount_codes_are_loading = true;
                axios
                    .get(this.serverURL + '/get_discount_codes/', {
                        params: {
                            from_date: this.selectedFromDate,
                            to_date: this.selectedToDate,
                        }
                    })
                    .then(response => {
                        this.discount_codes = response.data;
                        this.discount_codes_are_loading = false;
                    })
                .catch(() => {
                    this.discount_codes_are_loading = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>